import React, { useState, useEffect } from "react";
import { Table } from "antd";
import moment from "moment";
import menuIcon from "../../assets/images/DeathModuleNew/Menu.png";
import { useHistory } from "react-router-dom";
import "../InsuranceNew/InsuranceDashboard.css";

export const InsuranceTableV2 = ({
  data,
  deletePost,
  page,
  setCurrentPage,
  totalPages,
}) => {
  const history = useHistory();

  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const cols_insurance = [
    {
      title: "Policy Name",
      dataIndex: "Policy Name (Person(s)/Property Insured)",
      key: "Policy Name (Person(s)/Property Insured)",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Policy Start Date",
      dataIndex: "Policy Start Date",
      key: "Policy Start Date",
      render: (record) =>
        record ? moment(record).format("MM/DD/YYYY") : "N/A",
    },
    {
      title: "Policy End Date",
      dataIndex: "Policy End Date",
      key: "Policy End Date",
      render: (record) =>
        record ? moment(record).format("MM/DD/YYYY") : "N/A",
    },
    {
      title: "Insurance Company",
      dataIndex: "Insurance Company",
      key: "Insurance Company",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Policy Number",
      dataIndex: "Policy Number",
      key: "Policy Number",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Monthly Premium",
      dataIndex: "Premium",
      key: "Premium",
      render: (_, record) => {
        const isAnnual =
        record["Annual / Monthly / One-Time"] === "Annual" ||
        record["Annual or Monthly"] === "Annual";
  
      const amount = isAnnual ? record.Premium / 12 : record.Premium;
  
      return amount
        ? `$ ${amount.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        : "N/A";
      },
    },
    {
      title: "Actions",
      key: "id",
      render: (record, index) => {
        return (
          <div key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}
            >
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        fnView(record);
                        setDropdown(false);
                      }}
                    >
                      View
                    </li>

                    <li
                      className="liHover"
                      onClick={() => {
                        fnEdit(record);
                        setDropdown(false);
                      }}
                    >
                      Update
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        deletePost(record.id);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}{" "}
          </div>
        );
      },
    },
  ];

  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };

  const fnEdit = (record) => {
    history.push(
      `/organizer/insurance/attributes/${record.module}/${record.id}`
    );
  };
  const fnView = (record) => {
    history.push(
      `/organizer/insurance/attributes/${record.module}/${record.id}/view`
    );
  };

  return (
    <React.Fragment>
      <div className="insuranceInfoMaincard">
        <h3 className="liablitycardheading">Insurance Policies</h3>
        <Table
          columns={cols_insurance}
          dataSource={data && data}
          pagination={{
            total: totalPages * 10, // Assuming 10 items per page
            current: page,
            onChange: (page) => {
              setCurrentPage(page);
            },
            pageSize: 10, // Number of items per page
          }}
        />
      </div>
    </React.Fragment>
  );
};
